import { PublicClientApplication } from '@azure/msal-browser';

const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: getEnv('REACT_APP_CLIENT_ID') || '00000000-0000-0000-0000-000000000000',
    authority: getEnv('REACT_APP_AUTHORITY') || 'https://login.microsoftonline.com/common',
    redirectUri: getEnv('REACT_APP_REDIRECT_URL') || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    loginRequestScopes: ['User.Read'],
  },
});

export const logoutRedirectUri = getEnv('REACT_APP_LOGOUT_REDIRECT_URI') || window.location.origin;
